module.exports = __webpack_public_path__ + "static/media/COTK2_1.4c65aa9c.png";